import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController, ToastController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { Storage } from '@ionic/storage';

import { BusinessPunchCardIconSelectPage } from '../business-punch-card-icon-select/business-punch-card-icon-select';

import { PunchCardSequence } from '../../models/punch-card-sequence';
import { BusinessPunchCardSequenceManagerHandler } from '../../providers/business-punch-card-sequence-handler';
import { Globals } from '../../providers/globals';
import { PunchCardIconProvider } from '../../providers/punch-card-icon';

import { Camera, CameraOptions } from '@ionic-native/camera';

@Component({
  selector: 'page-business-punch-card-sequence-manager',
  templateUrl: 'business-punch-card-sequence-manager.html',
})
export class BusinessPunchCardSequenceManagerPage {
	@ViewChild('fileInput') fileInput;

	punchCardSequence: PunchCardSequence;
	private punchCardSequenceManagerForm : FormGroup;
	public imageSrc: string;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;
	imageChanging: boolean = false;
	sentPunchCardId: any;

  	constructor(
  		private punchCardIconProvider: PunchCardIconProvider,
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public punchCardSequenceManagerHandler: BusinessPunchCardSequenceManagerHandler,
		public storage: Storage,
		private camera: Camera,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController
		) {

		this.punchCardSequence = navParams.get('punchCardSequence');
		this.sentPunchCardId = navParams.get('punchCardId');
		
		let punchCardId = (this.punchCardSequence.PunchCardId ? 
						   this.punchCardSequence.PunchCardId : 
						   this.sentPunchCardId);

	    this.punchCardSequenceManagerForm = this.formBuilder.group({
	    	"Id": [''],
	    	"PunchCardId": [punchCardId],
	    	"PunchCardIconId": [1],

		  	"PunchQuantity":  [3, Validators.required],
		  	"PunchMonetaryValue":  [0, Validators.required],

		  	"RewardMonetaryValue":  [0, Validators.required],
		    "RewardDescription":  ['', Validators.required],

		    "RewardImagePath": [''],
		    "Instructions": ['', Validators.required],
		    "Terms":  [''],
		    "ExpirationDaysAmount": [30],
		    "HasCustomImage": [false],
	   	});   

	   	if(this.punchCardSequence.Id != null){
	   		this.loadPunchCardSequence(this.punchCardSequence);
	    }else{
	    	this.punchCardIconProvider.reset();
	    }
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessPunchCardSequenceManagerPage');
	}

	loadPunchCardSequence(punchCardSequence){
		this.isLoading = true;

  		this.punchCardSequenceManagerForm.patchValue(
    			punchCardSequence
    	)

    	if(this.punchCardSequence.Id!=''){
    		this.punchCardIconProvider.icon = {
    			Id: punchCardSequence.PunchCardIconId,
    			IconPath: punchCardSequence.IconPath
    		} 
    	}

  		this.filePath = this.globals.fileUrl + punchCardSequence.RewardImagePath;

  		this.isLoading = false;
	}

	addToPunchCard(add){

		var punchQuantity = this.punchCardSequenceManagerForm.controls['PunchQuantity'].value;

		if((add && punchQuantity >= 2) || (!add && punchQuantity > 2)){
			punchQuantity = add ? punchQuantity + 1 : punchQuantity - 1;
		}

		this.punchCardSequenceManagerForm.controls['PunchQuantity'].setValue(punchQuantity) 
	}

	createPunchArray(punchQuantity){
		if (!punchQuantity)
			punchQuantity = 2;
		
		var punches = new Array(punchQuantity);

		return punches;
	}

	deletePunchCardSequence(){
		this.deleteIsLoading = true

		this.punchCardSequenceManagerHandler.deletePunchCardSequence(this.punchCardSequence.Id, (result)=>{
			
			this.deleteIsLoading = false

			if(result.Success) {
				this.navCtrl.pop();
			} else {
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}

		});	
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this reward?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.deletePunchCardSequence()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	selectIcon(){
        this.navCtrl.push(BusinessPunchCardIconSelectPage);		
	}

	onSubmit(){		
		if(this.saveIsLoading) return;

		this.saveIsLoading = true;

		console.log(this.punchCardSequenceManagerForm.value);

  		this.punchCardSequenceManagerForm.patchValue({
  			PunchCardIconId: this.punchCardIconProvider.icon.Id
  		})		

		if(this.punchCardSequenceManagerForm.value.Id != ''){
			this.punchCardSequenceManagerHandler
				.udpatePunchCardSequence(this.punchCardSequenceManagerForm.value.Id, this.punchCardSequenceManagerForm.value, (result)=>{
			  	if(result.Success) {
					let toast = this.toastCtrl.create({
						message: 'Level has been updated',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();	
				} else {
					let alert = this.alertCtrl.create({
		              title: 'Error',
		              subTitle: result.Message,
		              buttons: ['Ok']
		            });

		            alert.present();
				}

			  	this.saveIsLoading = false;
			})
		} else {
			this.punchCardSequenceManagerHandler
			.createPunchCardSequence(this.punchCardSequenceManagerForm.value, (result)=>{			  
				let toast = this.toastCtrl.create({
					message: 'Level has been created',
					duration: 3000,
					position: 'bottom'
				});

				toast.present();	

				this.punchCardSequence = result;			

				this.loadPunchCardSequence(this.punchCardSequence);  	

			  	this.saveIsLoading = false;
			})
		}		  	
	}

	chooseImageSource() {
	   let actionSheet = this.actionSheetCtrl.create({
	     title: 'Choose the source for an image',
	     buttons: [
	       {
	         text: 'Camera',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(true)
	         }
	       },
	       {
	         text: 'Image Gallery',
	         handler: () => {
	           console.log('Archive clicked');

	           this.getImage(false)
	         }
	       },
	       {
	         text: 'Cancel',
	         role: 'cancel',
	         handler: () => {
	           console.log('Cancel clicked');
	         }
	       }
	     ]
	   });

	   actionSheet.present();
	}

	private getImage (fromCamera): void {
		var sourceType = fromCamera ? this.camera.PictureSourceType.CAMERA : this.camera.PictureSourceType.PHOTOLIBRARY

		const options: CameraOptions = {
	  	  	sourceType: sourceType,
		  	destinationType: this.camera.DestinationType.DATA_URL,  
		    mediaType: this.camera.MediaType.PICTURE,    
		    allowEdit: true,
		    quality: 30,
		    targetWidth: 500,
		    targetHeight: 500,
		    encodingType: this.camera.EncodingType.PNG,      
		    correctOrientation: true
		}

		this.imageChanging = true;

		this.camera.getPicture(options).then((dataUrl) => {
			if(!this.filePath){
				let imageData = 'data:image/png;base64,' + dataUrl;

		    	this.imageSrc = imageData;

		    	var imgObject = {
			    	"RewardImagePath": imageData,
			    }

		    	this.punchCardSequenceManagerForm.patchValue(
		    		imgObject
		    	) 

		    }


			if(this.punchCardSequence.Id){

	    		this.punchCardSequenceManagerHandler
	    		.updatePunchCardSequenceImage({
	    			id: this.punchCardSequence.Id,
	    			imageString: 'data:image/png;base64,' + dataUrl,
	    			cb: (data)=>{ 
						

						console.log("New image path: " + data.Data);

						this.punchCardSequence.RewardImagePath = data.Data;
						this.punchCardSequence.HasCustomImage = true

						var imgObject = {
				    		"RewardImagePath": data.Data,
				    		"HasCustomImage": true
				    	}

				    	console.log(imgObject);

				    	this.punchCardSequenceManagerForm.patchValue(
				    		imgObject
				    	) 

				    	this.imageSrc = null

				    	this.filePath = this.globals.fileUrl + this.punchCardSequence.RewardImagePath;

				    	this.imageChanging = false;
					}
				})
	    	}

			}, (err) => {
			 // Handle error
			 alert('Unable to take photo');
			 this.imageChanging = false;
			});
	}

	getPicture() {
	    if (Camera['installed']()) {

	      this.chooseImageSource();
	    
	    } else {
	      
	      this.fileInput.nativeElement.click();
	    
	    }
	}

	processWebImage(event) {
	    let reader = new FileReader();

	    reader.onload = (readerEvent) => {

		    let imageData = (readerEvent.target as any).result;

		    if(!this.filePath){

		    	this.imageSrc = imageData;

		    	var imgObject = {
			    	"RewardImagePath": imageData,
			    }

		    	this.punchCardSequenceManagerForm.patchValue(
		    		imgObject
		    	) 

		    }

		    if(this.punchCardSequence.Id){

			    this.imageChanging = true;

				this.punchCardSequenceManagerHandler
				.updatePunchCardSequenceImage({
					id: this.punchCardSequence.Id,
					imageString: imageData,
					cb: (data)=>{ 
						this.imageChanging = false;

						console.log("New image path: " + data.Data);

						this.punchCardSequence.RewardImagePath = data.Data;
						this.punchCardSequence.HasCustomImage = true

						var imgObject = {
				    		"RewardImagePath": data.Data,
				    		"HasCustomImage": true
				    	}

				    	console.log(imgObject);

				    	this.punchCardSequenceManagerForm.patchValue(
				    		imgObject
				    	) 

				    	this.imageSrc = null

				    	this.filePath = this.globals.fileUrl + this.punchCardSequence.RewardImagePath;
					}
				})
			}
	    }; 

	    reader.readAsDataURL(event.target.files[0]);
	}

	getProfileImageStyle() {
	    // return 'url(' + this.form.controls['profilePic'].value + ')'
	    return this.punchCardSequenceManagerForm.controls['RewardImagePath'].value
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-punch-card-sequence-manager/business-punch-card-sequence-manager.ts